import React from 'react';

function Field({ value = [], maxLength }) {
  if (!Array.isArray(value) || value.length === 0) {
    return <>-</>;
  }

  const items = maxLength ? value.slice(0, maxLength) : value;

  return (
    <>
      {items.map((item, index) => (
        <div key={index}>{item}</div>
      ))}
      {maxLength && value.length > maxLength && <div>...</div>}
    </>
  );
}

export default Field;
